<template>
    <div class="happySpace">
        <div class="happySpace_top">
            <img src="@/assets/images/grow-club/back.png" class="happySpace_top_goback" @click="goback" />
            <img src="@/assets/images/grow-club/emotion-people.png" class="happySpace_top_right" />
        </div>
        <div class="happySpace_content" v-if="!nodataFlag">
          <div class="happySpace_content_list">
            <div class="happySpace_content_item" v-for="(item, index) in branchList" :key="index" @click="goDetail(item)" >
              <p>{{item.name}}</p>
            </div>
          </div>
        </div>
        <div class="nodata_part" v-if="nodataFlag">
            <happy-no/>
        </div>
    </div>
</template>
<script>
import {  getRequest  } from '../../assets/js/api'
import {horizontalScreen} from '../../assets/js/horizontal';
import happyNo from '../../components/parent-course/happy-no.vue';
import BScroll from "better-scroll";
export default {
  components: { happyNo },
    name: 'happy-space-tab',
    data() {
        return {
            //分级菜单列表的参数
            layerParams: {
                columnLayer:'一级栏目',
                page:1,//当前页
                limit:100,//每页多少条
            },
            branchList:[],//首页一级维度的数据
            infoObj: {},//当前信息对象的集合
            nodataFlag: false,
        }
    },
    created() {
        this.infoObj = this.$storage.getStore('happyInfo')
    },
    mounted() {
        horizontalScreen(); //横屏
        // 获取当前层级下的目录
        this.getColumnBranch( this.infoObj.id)
    },
    methods: {
        //点击返回按钮
        goback() {
            this.$router.back();
        },
        //tab切换
        tabContentClick() {

        },
        //跳转子集页面
        goDetail(item) {
            this.$storage.setStore('happyInfoTab',item)
            this.$router.push({
                path:'/happySpaceDetail',
                query:{
                    title: item.name
                }
            })
        },
        // 根据id获取栏目下的内容
        async getColumnBranch(id) {
            try {
                getRequest(`/api-content/column/branches/` + id + '?code=ET').then(res => {
                    let { code, message, data } = res
                    if(res && code === 200) {
                        if(data && data.length > 0) {
                            // this.dataExit = false
                            this.nodataFlag = false
                            this.branchList = data
                        } else {
                            // 没数据，缺省图
                            // this.dataExit = true
                            this.branchList = []
                            this.nodataFlag = true
                        }
                        // 列表滚动效果
                        this.$nextTick(() => {
                          let bs = new BScroll('.happySpace_content', {
                            pullUpLoad: true,
                            // scrollbar: true,
                            pullDownRefresh: true,
                            scrollX: true,
                            scrollY: false,
                            bounce: false,
                            click: true,
                            quadrant: 2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
                          })
                        })
                    } else {
                        this.branchList = []
                        this.nodataFlag = true
                        // this.dataExit = true
                        // 没数据，缺省图
                        Toast(message)
                    }
                })
            } catch (error) {
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.happySpace {
    width: 100%;
    height: 100%;
    background: url(./../../assets/images/grow-club/space-bg.png);
    background-size: cover;
    .happySpace_top {
        display: flex;
        justify-content: space-between;
        .happySpace_top_goback {
            width: 29px;
            height: 29px;
            margin: 15px 0 0 15px;
        }
        .happySpace_top_right {
            width: 123px;
            height: 53px;
            margin: 10px 20px 0 0;
        }
    }
    .happySpace_content {
        margin-top: 55px;
        // padding-right: 23px;
        display: flex;
        width: 100%;
        overflow-x: scroll;
        .happySpace_content_list{
          display: flex;
        }
        .happySpace_content_item {
            margin-left: 30px;
            width: 210px;
            height: 127px;
            background: url(./../../assets/images/grow-club/space-box.png);
            background-size: cover;
            display: flex;
            align-items: center;
            p {
                width: 90px;
                margin-left: 97px;
                margin-right: 20px;
                text-align: left;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #D55514;
            }
        }
    }
    .happySpace_content::-webkit-scrollbar {
        display: none;
    }
}
::-webkit-scrollbar {
width: 0px;
}

::-webkit-scrollbar-track {
background-color: none;
}

::-webkit-scrollbar-thumb {
background-color: none;
}

::-webkit-scrollbar-thumb:hover {
background-color: none;
}

::-webkit-scrollbar-thumb:active {
background-color: none;
}
</style>
